import { OneAddCommentDocument } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { handleResult } from 'modules/core/lib/handleMutation'
import { OneCreateAction, OneCreationActionResolver } from 'modules/core/lib/oneCreateActions/types'
import { POSTS_POLICIES } from 'modules/posts/lib/postsPolicies'

const useAddCommentActionResolver: OneCreationActionResolver = () => {
  const { navigation } = useNavigation()

  const [addComment, { loading }] = useMutation(OneAddCommentDocument, {
    extractorFn: (data) => data.postsMutations.createPostsComment,
    errorPolicy: 'all',
  })

  const addCommentHandler = async (args: {
    postId: string
    text: string
    mentionedAccessIds?: string[]
  }) => {
    const result = await addComment({
      variables: {
        postId: args.postId,
        text: args.text,
        mentionedAccessIds: args.mentionedAccessIds ?? [],
      },
    })

    const handled = handleResult(result, (_errors) => {})

    if (handled.success && handled.data.comment?.postId) {
      return {
        to: navigation.communities.post.id.fullPath({ id: handled.data.comment.postId }),
        data: args,
      }
    }

    return handled
  }

  return {
    resolver: addCommentHandler,
    loading,
  }
}

export const AddCommentAction: OneCreateAction = {
  actionResolver: useAddCommentActionResolver,
  policies: [POSTS_POLICIES.groupCanPostSomewhere],
}
